export const theme = {
  color: {
    font: "rgba(40, 46, 46, .9)",
    heading: "hsl(206, 100%, 15%)",
    white: "rgba(255, 255, 255, 1)",

    base: "#497a96",
    baseLight: "#a0cadd",
    baseExtraLight: "#d9ebf0",
    baseDark: "#154164",
    baseExtraDark: "#002944",
    baseSoftDarkOp: "#0b2d3d",
    baseOp: "rgba(0,70,107,0.9)",

    sec: "#d15757",
    secLight: "#ffe2a2",
    secExtraLight: "#fff4da",
    secDark: "#797264",
    secExtraDark: "#494642",

    grey1: "hsl(190, 40%, 95%)",
    grey2: "hsl(210, 30%, 90%)",
    grey3: "hsl(210, 20%, 80%)",
    grey4: "hsl(210, 15%, 65%)",
    grey5: "hsl(210, 13%, 50%)",
    grey6: "hsl(210, 15%, 40%)",
    grey7: "hsl(210, 20%, 30%)",
    grey8: "hsl(210, 30%, 20%)",
    grey9: "hsl(210, 40%, 15%)",

    base1: "hsl(190, 100%, 50%)",
    base2: "hsl(190, 100%, 75%)",
    base3: "hsl(190, 100%, 90%)",
    base4: "hsl(190, 100%, 95%)",
    base5: "hsl(190, 100%, 100%)",
    base6: "hsl(190, 100%, 100%)",
    base7: "hsl(190, 100%, 100%)",
    base8: "hsl(190, 100%, 100%)",
    base9: "hsl(190, 100%, 100%)",

    prim1: "hsl(206, 100%, 15%)",
    prim2: "hsl(206, 70%, 25%)",
    prim3: "hsl(204, 40%, 35%)",
    prim4: "hsl(204, 40%, 45%)",
    prim5: "hsl(202, 50%, 55%)",
    prim6: "hsl(202, 50%, 65%)",
    prim7: "hsl(200, 60%, 75%)",
    prim8: "hsl(200, 80%, 85%)",
    prim9: "hsl(200, 100%, 95%)",

    sec1: "hsl(358, 79%, 47%)",
    sec2: "hsl(358, 79%, 30%)",
    sec3: "hsl(358, 79%, 20%)",
    sec4: "hsl(358, 79%, 15%)",
    sec5: "hsl(358, 79%, 100%)",
    sec6: "hsl(358, 79%, 100%)",
    sec7: "hsl(358, 79%, 100%)",
    sec8: "hsl(358, 79%, 100%)",
    sec9: "hsl(358, 79%, 100%)",

    opacityBlack06: "rgba(0, 0, 0, .6)",
  },

  breakpoints: {
    xs: "0px",
    sm: "576px",
    md: "980px",
    lg: "1320px",
    xl: "1921px",
  },

  font: {
    main: "Titillium Web",
    header: "Titillium Web",
    special: "Titillium Web",

    weight: 300,
    weightBold: 700,
    weightH: 700,

    sizeSmall: "16px",

    size: {
      p: {
        xs: "16px",
        s: "17px",
        m: "18px",
        l: "19px",
        xl: "20px",
      },

      l: {
        xs: "12px",
        s: "14px",
        m: "14px",
        l: "14px",
        xl: "14px",
      },

      h1: {
        xs: "40px",
        s: "42px",
        m: "44px",
        l: "46px",
        xl: "48px",
      },

      h2: {
        xs: "32px",
        s: "34px",
        m: "36px",
        l: "38px",
        xl: "40px",
      },

      h3: {
        xs: "24px",
        s: "26px",
        m: "28px",
        l: "30px",
        xl: "32px",
      },

      h4: {
        xs: "22px",
        s: "23px",
        m: "24px",
        l: "25px",
        xl: "26px",
      },

      h5: {
        xs: "19px",
        s: "20px",
        m: "21px",
        l: "22px",
        xl: "23px",
      },

      h6: {
        xs: "17px",
        s: "18px",
        m: "19px",
        l: "20px",
        xl: "21px",
      },
    },

    lineH: {
      p: {
        xs: "1.2",
        s: "1.3",
        m: "1.4",
        l: "1.4",
        xl: "1.5",
      },

      l: {
        xs: "1.1",
        s: "1.1",
        m: "1.1",
        l: "1.1",
        xl: "1.1",
      },

      h1: {
        xs: "1.2",
        s: "1.2",
        m: "1.2",
        l: "1.2",
        xl: "1.2",
      },

      h2: {
        xs: "1.1",
        s: "1.1",
        m: "1.1",
        l: "1.1",
        xl: "1.1",
      },

      h3: {
        xs: "1.2",
        s: "1.3",
        m: "1.3",
        l: "1.3",
        xl: "1.3",
      },

      h4: {
        xs: "1.2",
        s: "1.3",
        m: "1.3",
        l: "1.3",
        xl: "1.3",
      },

      h5: {
        xs: "1.1",
        s: "1.1",
        m: "1.1",
        l: "1.1",
        xl: "1.1",
      },

      h6: {
        xs: "1.5",
        s: "1.5",
        m: "1.5",
        l: "1.6",
        xl: "1.7",
      },
    },
  },
}
